module.exports = __webpack_public_path__ + "img/3.78057311.jpg";